// extracted by mini-css-extract-plugin
var _1 = "OptionsMenu_actions__af1fb";
var _2 = "OptionsMenu_borders__bff93";
var _3 = "OptionsMenu_dropdownItem__36041";
var _4 = "OptionsMenu_iconActive__43307";
var _5 = "OptionsMenu_label__b9aac";
var _6 = "OptionsMenu_options__370cf";
var _7 = "OptionsMenu_settings__3afaf";
export { _1 as "actions", _2 as "borders", _3 as "dropdownItem", _4 as "iconActive", _5 as "label", _6 as "options", _7 as "settings" }
